import { t } from "i18next";
import * as Yup from "yup";

export const createProductInitialValues = {
  temp: {
    carts: {
      es: "",
      pt: "",
      en: "",
    },
    equivalences: {
      quantity: "",
      portionEs: "",
      portionEn: "",
      portionPt: "",
    },
  },
  product: {
    productEs: "",
    productEn: "",
    productPt: "",
  },
  equivalences: [],
  carts: [],
  nutritionalInformation: {
    proteins: 0,
    fats: 0,
    fibers: 0,
    carbohydrates: 0,
    calories: 0,
  },
};

export type CreateProductValues = typeof createProductInitialValues;

export const createProductValidationSchema = Yup.object({
  temp: Yup.object({
    carts: Yup.object({
      es: Yup.string().notRequired(),
      pt: Yup.string().notRequired(),
      en: Yup.string().notRequired(),
    }),
    equivalences: Yup.object({
      quantity: Yup.number().notRequired(),
      portionEs: Yup.string().notRequired(),
      portionEn: Yup.string().notRequired(),
      portionPt: Yup.string().notRequired(),
    }),
  }),
  product: Yup.object({
    productEs: Yup.string().required(
      t("contexts.nutrition.product_name_required")
    ),
    productEn: Yup.string().required(
      t("contexts.nutrition.product_name_required")
    ),
    productPt: Yup.string().required(
      t("contexts.nutrition.product_name_required")
    ),
  }),
  carts: Yup.array(
    Yup.object({
      es: Yup.string().required(),
      en: Yup.string().required(),
      pt: Yup.string().required(),
    })
  ).min(1, t("contexts.nutrition.carts_required")),
  equivalences: Yup.array(
    Yup.object({
      quantity: Yup.number().required(),
      portionEs: Yup.string().required(),
      portionEn: Yup.string().required(),
      portionPt: Yup.string().required(),
    })
  ).min(1, t("contexts.nutrition.equivalences_required")),
  nutritionalInformation: Yup.object({
    proteins: Yup.number()
      .min(0.01, t("contexts.nutrition.proteins_min"))
      .required(t("contexts.nutrition.proteins_required")),
    fats: Yup.number()
      .min(0.01, t("contexts.nutrition.fats_min"))
      .required(t("contexts.nutrition.fats_required")),
    fibers: Yup.number()
      .min(0.01, t("contexts.nutrition.fibers_min"))
      .required(t("contexts.nutrition.fibers_required")),
    calories: Yup.number()
      .min(0.01, t("contexts.nutrition.calories_min"))
      .required(t("contexts.nutrition.calories_required")),
    carbohydrates: Yup.number()
      .min(0.01, t("contexts.nutrition.carbohydrates_min"))
      .required(t("contexts.nutrition.carbohydrates_required")),
  }),
});
